import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes/index'
// utils
import { ellipsis } from 'polished'
import { isColorLight } from 'utils/tree'

export const ResponseTypeWrapper = styled.div``

export const OptionsWrapper = styled.div`
  margin-top: 6px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const Option = styled.div<{ selected: boolean; color: string; disabled: boolean }>`
  padding: 4px 16px;
  border-radius: 8px;
  background-color: ${({ selected, color }) => (selected ? color : colors.gray150)};
  color: ${({ selected, color }) => (isColorLight(selected ? color : colors.gray150) ? colors.black : colors.white)};
  cursor: pointer;
  border: ${({ selected }) => (selected ? 'none' : '1px solid gray')};
  user-select: none;
  text-align: center;
  height: fit-content;
  flex: 1;

  ${({ disabled, selected }) =>
    disabled &&
    (selected
      ? css`
          pointer-events: none;
        `
      : css`
          pointer-events: none;
          border-style: dotted;
          color: ${colors.gray280};
        `)};

  &:hover {
    opacity: 0.8;
  }

  ${ellipsis('100%')};
`

export const OptionWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1;
  width: 100%;
`
